// @flow

// Libs
import { defineMessages } from 'react-intl'

// Constants
import {
  ATTR_COMMENT_ID,
  ATTR_CROP,
  ATTR_YIELD_TARGET,
  ATTR_FIELD,
  ATTR_DATE_CREATED,
  ATTR_RECOMMENDED_RATES,
} from 'hfty-datatable-comments/src/constants'

// Messages
export default defineMessages({
  [ATTR_COMMENT_ID]: {
    id: 'hfty.dataTable.comments.id',
    defaultMessage: 'ID',
  },
  [ATTR_CROP]: {
    id: 'hfty.dataTable.comments.crop',
    defaultMessage: 'Crop',
  },
  [ATTR_YIELD_TARGET]: {
    id: 'hfty.dataTable.comments.yieldTarget',
    defaultMessage: 'Yield Target',
  },
  [ATTR_FIELD]: {
    id: 'comments.dataTable.field',
    defaultMessage: 'Field',
  },
  [ATTR_DATE_CREATED]: {
    id: 'dateCreated',
    defaultMessage: 'Date Created',
  },
  [ATTR_RECOMMENDED_RATES]: {
    id: 'recommended_rates',
    defaultMessage: 'Recommended Rates',
  },
})
